import { MyBookingsList } from "../components/my-bookings-list.component";

export function MyBookingsPage() {
  return <MyBookingsList />;
}
